export const DEFAULT_CURRENCY = 'USD'

/** Mirrors the legacy `initCurrenciesListener`'s algorithm: `USD` plus the partner's local
 *  currency (falling back to their default currency) when it isn't already `USD`. */
export const getAvailableCockpitCurrencies = (
  localCurrency?: string,
  defaultCurrency?: string
): string[] => {
  const currencies = [DEFAULT_CURRENCY]
  const selectedValue = localCurrency || defaultCurrency

  if (selectedValue && !currencies.includes(selectedValue)) {
    currencies.push(selectedValue)
  }

  return currencies
}
